<template>
  <div class="e-url">
    <input
      class="e-url"
      type="text"
      v-if="editMode"
      :class="hasError ? 'is-invalid' : ''"
      :name="name"
      ref="input"
      @blur="onBlur"
      @change="change"
      @input="onInput"
      v-on:keyup.enter.prevent="toggleEdit()"
      :placeholder="getPlaceholder"
      v-bind:disabled="disabled"
      v-bind:data-validate-alias="validateAlias"
      v-model.trim="model[name]"/>
    <a
      v-else-if="model[name]"
      :href="model[name]"
      target="_blank"
    >{{model[name]}}</a>
    <a
      v-else
    > - </a>
    <e-button-edit
      v-if="!disabled && !this.isEmpty"
      @click="toggleEdit()"
    ></e-button-edit>
  </div>
</template>

<script>
  // data-* attributes used for debug
  export default {
    name: 'e-url',
    data () {
      return {
        error: null,
        editMode: true
      }
    },
    props: {
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validateAlias: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: 'Укажите сайт вида http://etton.ru'
      },
      mask: {
        type: String,
        default: null
      },
      onValidate: {
        type: Function,
        default: (obj) => obj
      }
    },
    computed: {
      getPlaceholder () {
        if (this.placeholder === null) {
          return ''
        }
        return this.placeholder
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      },
      isEmpty () {
        return !this.model[this.name]
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }

      if (!this.isEmpty || this.disabled) {
        this.stopEdit()
      }
    },
    destroy () {
      if (this.formValidator) {
        this.formValidator.unsubscribeInput(this)
      }
    },
    methods: {
      toggleEdit () {
        if (this.editMode) {
          this.stopEdit()
        } else {
          this.editMode = true
        }
      },
      stopEdit () {
        if (this.disabled) {
          this.editMode = false
        }

        if (this.formValidator) {
          const {hasError} = this.formValidator.validate(null, this.validateAlias || this.name)
          if (hasError) {
            return
          }
        }

        if (!this.isEmpty) {
          this.editMode = false
        }
        // this.$emit('enter', $event)
      },
      onBlur ($event) {
        this.$emit('blur', $event)
      },
      onInput (e) {
        this.$emit('input', e)
      },
      change ($event) {
        this.$emit('change', $event)
      },
      getElement () {
        return this.$refs.input
      },
      getValidUrl (inp) {
        const str = inp.toString()
        if (str.startsWith('http') === false) {
          return null
        }

        try {
          const url = new URL(str)
          return url.href
        } catch (e) {
          console.error(e)
          return false
        }
      },
      validate () {
        let msg = ''
        let validUrl = ''

        if (this.required && this.isEmpty) {
          msg += 'Заполните поле'
        }

        if (!msg && !this.isEmpty) {
          validUrl = this.getValidUrl(this.model[this.name])
          validUrl && this.$set(this.model, this.name, validUrl)
        }

        if (!msg && !this.isEmpty && !validUrl) {
          msg += 'Ссылка должна быть вида http://etton.ru'
        }

        if (msg) {
          this.editMode = true
        } else {
          if (!this.isEmpty) {
            this.editMode = false
          }
        }

        if (this.disabled) {
          msg = ''
        }

        return this.onValidate({
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement(),
          model: this.model
        })
      }
    }
  }
</script>

